
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { ReportDetail } from '@/types/salary';
import { SalaryReportTable } from './salary/SalaryReportTable';
import { Skeleton } from '@/components/ui/skeleton';

interface SalaryReportDialogProps {
  isOpen: boolean;
  reports: ReportDetail[];
  onClose: () => void;
  isLoading?: boolean;
}

export function SalaryReportDialog({
  isOpen,
  onClose,
  reports,
  isLoading,
}: SalaryReportDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[95vw] w-[95vw] lg:w-[90vw] overflow-x-auto max-h-[90vh] overflow-y-scroll">
        <DialogHeader>
          <DialogTitle>รายงานเงินเดือน</DialogTitle>
        </DialogHeader>
        {isLoading ? (
          <div className="space-y-3 py-4">
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-3/4" />
          </div>
        ) : (
          <SalaryReportTable reports={reports} />
        )}
      </DialogContent>
    </Dialog>
  );
}
